import { useMutation, useQuery } from 'react-query';
import { ProfileSetup_About, ProfileSetup_Service, RemovePancard, RemoveSamples, UploadMedia } from '../../../store/apiCalls/profilesetup';
import { genericError } from '../../../utils';

function OnAboutSubmit(sucessHandler) {
    return {
        ...useMutation(ProfileSetup_About, {
            onSuccess: (data) => { sucessHandler(data) },
            onError: (errMsg) => {
                genericError(errMsg.response.data);
            },
        })
    }
}

function OnUpload(sucessHandler) {
    return {
        ...useMutation(UploadMedia, {
            onSuccess: (data) => { sucessHandler(data) },
            onError: (errMsg) => {
                genericError(errMsg.response.data);
            },
        })
    }
}
function OnMediaDelete(sucessHandler) {
    return {
        ...useMutation(RemoveSamples, {
            onSuccess: (data) => { sucessHandler(data) },
            onError: (errMsg) => {
                genericError(errMsg.response.data);
            },
        })
    }
}
function OnPancardDelete(sucessHandler) {
    return {
        ...useMutation(RemovePancard, {
            onSuccess: (data) => { sucessHandler(data) },
            onError: (errMsg) => {
                genericError(errMsg.response.data);
            },
        })
    }
}

function OnServiceSubmit(sucessHandler){
    return {
        ...useMutation(ProfileSetup_Service, {
            onSuccess: (data) => { sucessHandler(data) },
            onError: (errMsg) => {
                genericError(errMsg.response.data);
            },
        })
    }
}
function FetchServicesOffered(fetchDetails,sucessHandler) {
    return {
        ...useQuery(
            ['profile'], () => fetchDetails(),
            {
                keepPreviousData: true,
                onSuccess: (rData) => {
                    sucessHandler(rData)
                },
                onError: (err) => {
                    genericError(err.response.data)
                }
            },
        )
    }
}
function FetchVendorDetails(fetchDetails,sucessHandler) {
    return {
        ...useQuery(
            ['VendorDetails'], () => fetchDetails(),
            {
                keepPreviousData: true,
                onSuccess: (rData) => {
                    sucessHandler(rData)
                },
                onError: (err) => {
                    genericError(err.response.data)
                }
            },
        )
    }
}


export {
    OnAboutSubmit,
    OnServiceSubmit,
    FetchServicesOffered,
    FetchVendorDetails,
    OnUpload,
    OnMediaDelete,
    OnPancardDelete
}
